import * as React from 'react';
import { graphql } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import PageWrapper from '../components/Common/PageWrapper/PageWrapper';
import PageTitleSection from '../components/Sections/Common/PageTitleSection/PageTitleSection';
import ContentNotFoundSection from '../components/Sections/Common/ContentNotFoundSection/ContentNotFoundSection';
import PicturesSection from '../components/Sections/Gallery/PicturesSection/PicturesSection';
import VideosSection from '../components/Sections/Gallery/VideosSection/VideosSection';
import HeroSection from '../components/Sections/Gallery/HeroSection/HeroSection';
import { PagesList } from '../enums/PagesList';
import { Application } from '../interfaces/professional/Professional';
import { TemplatesList } from '../enums/TemplatesList';

const Media = ({ data, location: windowLocation }: Application) => {
  const { t } = useTranslation();
  const { longName, additionalPictures, videos, template } = data.professional.data;

  return (
    <PageWrapper
        windowLocation={windowLocation}
      template={template.template as TemplatesList}
      currentPage={t('header.menu.gallery.label')}
      color={template.color}
      pageId={PagesList.GALLERY}
      metaDescription={t('SEO.gallery.description', { longName })}
      metaTitle={t('SEO.gallery.title', { longName })}
    >
      <PageTitleSection template={template.template as TemplatesList}>{t('gallery.h1Title')}</PageTitleSection>
      <HeroSection pageTitle={t('gallery.h1Title')} template={template.template as TemplatesList} />
      {!additionalPictures.length && !videos.length && <ContentNotFoundSection template={template.template as TemplatesList} />}
      {!!additionalPictures.length && <PicturesSection pictures={additionalPictures} template={template.template as TemplatesList} />}
      {!!videos.length && <VideosSection items={videos} template={template.template as TemplatesList} />}
    </PageWrapper>
  );
};

export default Media;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    professional {
      data {
        template {
          template
          color
        }
        shortName
        longName
        videos
        additionalPictures {
          id
          url
          group
          description
        }
      }
    }
  }
`;
